import { render } from "./HeroAuthConferenceDashboard.vue?vue&type=template&id=9330bd78&scoped=true"
import script from "./HeroAuthConferenceDashboard.vue?vue&type=script&lang=js"
export * from "./HeroAuthConferenceDashboard.vue?vue&type=script&lang=js"

import "./HeroAuthConferenceDashboard.vue?vue&type=style&index=0&id=9330bd78&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9330bd78"]])

export default __exports__